// src/components/SimpleComponents/SimpleColorPicker.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { ColorPicker } from 'antd';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
// Scoped style: reduces trigger to 40px (matching SimpleInput height) and
// corrects the inner color block margin by -1px on each axis to stay centred.
const SCOPED_STYLE = `
  .simple-color-picker .ant-color-picker-color-block {
    margin-top: -1px;
    margin-right: -1px;
  }
`;

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimpleColorPicker = ({ format = 'hex', size = 'small', style = {}, ...props }) => (
  <>
    <style>{SCOPED_STYLE}</style>
    <ColorPicker
      rootClassName="simple-color-picker"
      format={format}
      size={size}
      style={{ width: 40, height: 40, ...style }}
      {...props}
    />
  </>
);

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleColorPicker;
